import { useLingui } from '@lingui/react/macro';
import { Trans } from '@lingui/react/macro';
import { parseISO } from 'date-fns';

import Stack from '@/design_system/Stack';
import IconRefusal from '@/icons/Refusal.svg';
import IconValidation from '@/icons/Validation.svg';
import { WARRANTY_OVERRIDE_REASONS } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { formatDate } from '@/utils/date';

import { Item } from './Item';

export const ArticleWarrantyApplicable = () => {
  const { t } = useLingui();

  return (
    <Item
      label={t({
        id: 'article.information.warranty-applicable.label',
        message: 'Warranty applicable',
      })}
      value={<WarrantyApplicable />}
    />
  );
};

const WarrantyApplicable = () => {
  const { i18n } = useLingui();
  const { article } = useArticleContext();

  const warrantyOverrideReason = WARRANTY_OVERRIDE_REASONS.find(
    (reason) => reason.id === article.warrantyOverrideReason
  );

  if (article.activeWarrantyType === 'override' && warrantyOverrideReason) {
    return (
      <Stack gap="0.25rem" row alignItems="center" flexWrap="nowrap">
        <IconValidation style={{ fontSize: '1.25rem' }} className="text-success" />
        {i18n._(warrantyOverrideReason.text)}
      </Stack>
    );
  }

  if (article.activeWarrantyType === 'supplier' && article.supplierWarrantyExpirationDate) {
    const dateToConsider =
      article.hasDistributorWarrantyExtension && !!article.distributorWarrantyExpirationDate
        ? article.distributorWarrantyExpirationDate
        : article.supplierWarrantyExpirationDate;

    const formattedExpirationDate = formatDate(parseISO(dateToConsider), {
      dateStyle: 'medium',
    });

    return (
      <Stack gap="0.25rem" row alignItems="center">
        <IconValidation style={{ fontSize: '1.25rem' }} className="text-success" />
        <Trans id="article.information.warranty-applicable.until.label">
          Until {formattedExpirationDate}
        </Trans>
      </Stack>
    );
  }

  if (article.activeWarrantyType === 'distributor' && article.distributorWarrantyExpirationDate) {
    const formattedExpirationDate = formatDate(
      new Date(article.distributorWarrantyExpirationDate),
      { dateStyle: 'medium' }
    );

    return (
      <Stack gap="0.25rem" row alignItems="center">
        <IconValidation style={{ fontSize: '1.25rem' }} className="text-success" />
        <Trans id="article.information.warranty-applicable.until.label">
          Until {formattedExpirationDate}
        </Trans>
      </Stack>
    );
  }

  return (
    <Stack gap="0.25rem" row alignItems="center">
      <IconRefusal style={{ fontSize: '1.25rem' }} className="text-warning" />
      <Trans id="article.information.warranty-applicable.not-applicable.label">No</Trans>
    </Stack>
  );
};
